module.exports = __webpack_public_path__ + "static/media/normal.c5a1b1d2.png";